    <div class="container wow fadeIn">
        <!--Grid column-->
        <div class="col-md-12 mb-2">
          <!-- Heading -->
          <h2 class="my-5 h2 text-center">Checkout form</h2>

                    <!-- Heading -->
                    <h4 class="d-flex justify-content-between align-items-center mb-3">
                      <span class="text-muted">Details</span>
                    </h4>
          
                    <!-- Cart itemsInCart -->
                    <ul class="list-group mb-3 z-depth-1">
                      <li class="list-group-item d-flex justify-content-between lh-condensed">
                        <div>
                        <strong>First Name:</strong> {{recepient.firstName}}
                        </div>
                        <div>
                          <strong>Middle Name:</strong> {{recepient.middleName}}
                        </div>
                        <div>
                          <strong>Surname:</strong> {{recepient.surname}}
                          </div>
                      </li>
                      <li class="list-group-item d-flex justify-content-between">
                        <div>
                          <strong>Sender Number:</strong> {{recepient.senderNumber}}
                          </div>
                          <div>
                            <strong>recepient Number:</strong> {{recepient.receiverNumber}}
                          </div>
                      </li>
                    </ul>

          <!-- Heading -->
          <h4 class="d-flex justify-content-between align-items-center mb-3">
            <span class="text-muted">Your cart</span>
          </h4>

          <!-- Cart itemsInCart -->
          <ul class="list-group mb-3 z-depth-1">
            <li v-for="(value, name, index) in itemsInCart" :value="value" :key="name"
              class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                {{value.count}} x {{value.row.description}}
              </div>
              <span class="text-muted">R{{value.row.totalAmount.toFixed(2)}}</span>
            </li>
            <li class="list-group-item d-flex justify-content-between">
              <span>Total (R)</span>
              <strong>R{{totalAmount.toFixed(2)}}</strong>
            </li>
          </ul>

          <!--cart-->
          <h4 v-if="showPaymentMethods" class="d-flex justify-content-between align-items-center mb-3">
            <span class="text-muted">Payment Methods</span>
          </h4>
          <!-- payment methods-->
          <!-- Cart -->
          <ul v-if="showPaymentMethods" class="list-group mb-3 z-depth-1">
            <li class="list-group-item d-flex">
              <div class="col-md-12">
                <span class="text-muted"><input type="radio" name="paymentMethod" value="wallet"
                    v-model="paymentMethod"></span>&nbsp;&nbsp;
                Umbai wallet &nbsp; &nbsp;
                <i class="fa fa-money fa-1x"></i>
              </div>
            </li>
            <li class="list-group-item d-flex ">
              <div class="col-md-12">
                <span class="text-muted"><input type="radio" name="paymentMethod" checked="true" value="#cc"
                    v-model="paymentMethod"></span>&nbsp;&nbsp;
                Credit/Cheque card &nbsp;&nbsp;
                <img class="img-fluid" src="img/visa.svg" height="24" alt="airtime" /> &nbsp; &nbsp;
                <img class="img-fluid" src="img/mastercard.svg" height="24" alt="airtime" />
              </div>
            </li>
            <li class="list-group-item d-flex">
              <div class="col-md-12">
                <span class="text-muted"><input type="radio" name="paymentMethod" value="#ef"
                    v-model="paymentMethod"></span>&nbsp;&nbsp;
                InstantEft &nbsp; &nbsp;
                <img class="img-fluid" src="img/instanteft.svg" height="24" alt="airtime" />
              </div>
            </li>
            <li class="list-group-item d-flex">
              &nbsp;&nbsp;&nbsp;&nbsp;
              Have a Coupon? &nbsp; No/Yes
              &nbsp;
              <base-switch @change="ShowCouponBox = !ShowCouponBox"></base-switch>
              &nbsp;&nbsp;

              <div class="col-mb-2" v-if="ShowCouponBox">
                <input class="form-control border border-success form-control-sm" placeholder="Enter Coupon code here"
                  type="text">
              </div>
            </li>
          </ul>
          <div>
            <button class="btn btn-primary btn-block" type="button" @click="paymentMethodStrategy">Pay</button>
          </div>
          <!--spinner-->
          <div class="vld-parent">
            <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
          </div>
          <!--spinner-->
          <!--payfast-->
          <form :action="paymentGateWay.payfasturl" method="post" id='payfast'>
            <input type="hidden" name="merchant_id" :value="paymentGateWay.merchantId" placeholder="merchant_id" />
            <input type="hidden" name="merchant_key" :value="paymentGateWay.merchantKey" placeholder="merchant_key" />
            <input type="hidden" name="return_url" :value="paymentGateWay.returnUrl" placeholder="return_url" />
            <input type="hidden" name="cancel_url" :value="paymentGateWay.cancelUrl" placeholder="cancel_url" />
            <input type="hidden" name="notify_url" :value="paymentGateWay.notifyUrl" placeholder="notify_url" />
            <input type="hidden" name="m_payment_id" :value="paymentGateWay.mPaymentId" placeholder="m_payment_id" />
            <input type="hidden" name="amount" :value="paymentGateWay.totalAmount" placeholder="amount" />
            <input type="hidden" name="item_name" :value="paymentGateWay.itemName" placeholder="item_name" />
            <input type="hidden" name="item_description" :value="paymentGateWay.itemDescription"
              placeholder="item_name" />
            <input type="hidden" name="signature" :value="paymentGateWay.signature" placeholder="signature" />
          </form>
          <!--payfast-->
        </div>
        <!--Grid column-->
    </div>